import { useState } from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';
import { McpScope } from '@masters-club/types';
import { decideMcpOAuthRequest, fetchMcpOAuthRequest } from '../api';

interface DecisionInput {
  approve: boolean;
  allowWrite: boolean;
}

/**
 * Состояние страницы OAuth-согласия: загрузка запроса, чекбокс записи, выбор площадки
 * и отправка решения. После успеха браузер уходит на redirectTo клиента.
 */
export function useMcpConsent(requestId: string | null) {
  const [allowWrite, setAllowWrite] = useState(true);
  // null — площадка домена запроса (request.data.tenantSlug), пока админ не выбрал другую.
  const [chosenTenant, setTenant] = useState<string | null>(null);

  const request = useQuery({
    queryKey: ['mcp-consent', requestId],
    queryFn: () => fetchMcpOAuthRequest(requestId ?? ''),
    enabled: requestId !== null && requestId.length > 0,
    retry: false,
    staleTime: Infinity,
  });

  const decision = useMutation({
    mutationFn: ({ approve, allowWrite: withWrite }: DecisionInput) => {
      const requested = request.data?.scopes ?? [];
      const scopes = requested.filter((scope) => scope !== McpScope.WRITE || withWrite);
      return decideMcpOAuthRequest(requestId ?? '', approve, approve ? scopes : [], chosenTenant);
    },
    onSuccess: (result) => {
      window.location.href = result.redirectTo;
    },
  });

  const tenant = chosenTenant ?? request.data?.tenantSlug ?? null;

  return { request, decision, allowWrite, setAllowWrite, tenant, setTenant };
}
